import { useState } from 'react';

import { useAuthUser } from 'auth/hooks';
import { VendorQuoteHelper } from 'quotes/helpers';
import { IVendorQuote } from 'quotes/types';

import { AttributesCard } from './AttributesCard';
import { EditAttributes } from './EditAttributes';

interface IProps {
  quote: IVendorQuote;
}

export const Attributes = ({ quote }: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { user } = useAuthUser();

  // Saved attributes ride on the quote details record, so no separate fetch is needed here.
  const attributes = quote?.attributes ?? null;

  // The BE 403s the save either way — this only removes a dead-end affordance, so the save path
  // still surfaces the BE message if the two ever disagree.
  const isEditBlocked = VendorQuoteHelper.isAttributesEditBlocked(quote);

  const spaAudienceBlockReason = VendorQuoteHelper.getSpaAudienceBlockReason(
    VendorQuoteHelper.getStoredSpaAudience(quote),
    VendorQuoteHelper.getSpaAudienceRights(user)
  );

  return (
    <>
      <AttributesCard
        attributes={attributes}
        tradeAgreementStatus={quote.tradeAgreementStatus}
        tradeAgreementError={quote.tradeAgreementError}
        tradeAgreementSentVersion={quote.tradeAgreementSentVersion}
        spaAudienceBlockReason={spaAudienceBlockReason}
        sentSpaStatus={quote.sentSpaStatus}
        isEditBlocked={isEditBlocked}
        onEdit={() => setIsEditOpen(true)}
      />

      <EditAttributes
        quoteId={quote.id}
        attributes={attributes}
        validUntil={quote.validUntil}
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
      />
    </>
  );
};
